/* eslint-disable no-new */
// 建立长连接
import Vue from 'vue'
import common from './common.js'
import router from '../../router'
import axios from 'axios'
Vue.prototype.$http = axios
//跨组件传值
import EventHandler from './EventHandler.js'
Vue.prototype.initLongConnection = function(){
    var channel = common.getCookie('channel')
    if(channel){
        var goEasy = new GoEasy({
            appkey: 'BC-adad2fdda0cd4824a5dfc242b5fb4435'
        });
        goEasy.subscribe({
            channel: channel,
            onMessage: function(message) {
            console.log('收到：' + message.content);
            var type=1;            
            if(window.location.href.indexOf("/screenIndex/signIn")!=-1||window.location.href.indexOf("/screenIndex/signDetail")!=-1){
                type = 1
            }else if(window.location.href.indexOf("/screenIndex/vote")!=-1){
                type = 2
            }else if(window.location.href.indexOf("/screenIndex/responder")!=-1){
                type = 3
            }else if(window.location.href.indexOf("/screenIndex/discuss")!=-1){
                type = 4
            }else if(window.location.href.indexOf("/screenIndex/pick")!=-1){
                type = 5
            }else{
                type = 0
            }
            try {
                var data = JSON.parse(message.content);
                if(type != 0|| window.location.href.indexOf("/loadingIn")!=-1){
                    common.setCookie('userId',data.userId,30)
                    common.setCookie('activityId',data.activityId,30)
                    common.setCookie('type',data.type,30)
                    if(data.ocId){
                        common.setCookie('ocId',data.ocId,30)
                    }
                }
                if(type == data.type){
                    if(data.type==1&&location.hash !='#/screenIndex/signIn'&&(!data.operation||data.operation==null)){
                        router.replace({path: '/screenIndex/signIn'})
                    }else{
                        if((!data.operation||data.operation==null)){
                            window.location.reload()
                    }else{
                        switch(data.type){
                            //点名相关操作
                            case 1:
                            if(data.operation == 1){
                                router.replace({path:'/loadingIn'})
                            }
                            if(data.operation == 2){
                                EventHandler.toggleEvent('changeTab',data.attach)
                                // if(data.attach == 1){
                                //     router.replace({path:'/screenIndex/signDetail?type=2'})
                                // }else{
                                //     router.replace({path:'/screenIndex/signDetail?type=1'})
                                // }
                            }
                            break;
                            //投票相关操作
                            case 2:
                            if(data.operation == 1){
                                router.replace({path:'/loadingIn'})
                            }
                            if(data.operation == 2){
                                EventHandler.toggleEvent('changeClass',data.attach)
                            }
                            if(data.operation == 3){
                                EventHandler.toggleEvent('votePicOperation',data.attach)
                            }
                            //抢答相关操作
                            case 3:
                            if(data.operation == 1){
                                router.replace({path:'/loadingIn'})
                            }
                            //讨论相关操作
                            case 4:
                            if(data.operation == 1){
                                router.replace({path:'/loadingIn'})
                            }
                            if(data.operation == 3){
                                EventHandler.toggleEvent('discussPicOperation',data.attach)
                            }
                            if(data.operation == 2){
                                EventHandler.toggleEvent('largeDiscussDetial',data.attach)
                            }
                            if(data.operation == 4){
                                EventHandler.toggleEvent('changeSort',data.attach)
                            }
                            // 选人相关操作
                            case 5:
                            if(data.operation == 1){
                                router.replace({path:'/loadingIn'})
                            }
                        }
                    } 
                    }
                                   
                }else{
                    switch(data.type){
                        case 1:
                            router.replace({path: '/screenIndex/signIn'})
                        break;
                        case 2:
                            router.replace({path: '/screenIndex/vote'})
                        break;
                        case 3:
                            router.replace({path: '/screenIndex/responder'})
                        break;
                        case 4:
                            router.replace({path: '/screenIndex/discuss'})
                        break;
                        case 5:
                            router.replace({path: '/screenIndex/pick'})
                        break;
                    }
                }
            } catch (e) {
                console.log(e);
            }
            }
        });
    }
    //心跳函数
    function heartBeat(Authorization,userId){
        Vue.prototype.$http.get(Vue.prototype.baseURL +'/appscreen/heartBeat/?userId='+userId+'&second=20',{headers: {
        'Authorization': Authorization
        }}).then((res)=>{
        console.log(res)
            //刷新cookie
            if(res.data.status == 'success'){
                common.setCookie('userId',common.getCookie('userId'),30)
                common.setCookie('activityId',common.getCookie('activityId'),30)
                common.setCookie('type',common.getCookie('type'),30)
                common.setCookie('screenKey',common.getCookie('screenKey'),30)
                common.setCookie('ocId',common.getCookie('ocId'),30)
                common.setCookie('channel',common.getCookie('channel'),30)
                common.setCookie('Authorization',common.getCookie('Authorization'),30)
            }
            if(res.data.status == 'fail'){
                clearInterval(inter)
                router.replace({
                    path: '/',
                    query: {redirect: router.currentRoute.fullPath}
                })
            }
      
        })
    }
    var Authorization = common.getCookie('Authorization')
    var userId = common.getCookie('userId')
    if(Authorization&&userId){
        heartBeat(Authorization,userId)
        var inter = setInterval(function(){
            heartBeat(Authorization,userId)
        },10000)
    }
}
if(common.getCookie('userId')){
    Vue.prototype.initLongConnection()
}


// WEBPACK FOOTER //
// ./src/common/js/longConnect.js